'use client'

import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline'
import React from 'react'

import { cn } from '@src/utils/tailwind'

interface QuantitySelectorProps {
  label: string
  value: number
  isInvalid?: boolean
  onChange: (value: number) => void
}

const containerClasses =
  'h-[60px] w-[160px] border border-bodi-gray-butters rounded-lg flex justify-center items-center overflow-hidden'

const buttonClasses =
  'h-full border-bodi-gray-butters w-11 text-body-md hover:bg-bodi-gray-pearl flex items-center justify-center'

const iconProps = {
  className: 'size-4',
  style: {
    strokeWidth: 3,
  },
}

function QuantitySelector({ label, value, isInvalid, onChange }: QuantitySelectorProps) {
  return (
    <div>
      {label && <p className="pb-2 pt-4 font-medium text-bodi-gray-medium">{label}</p>}
      <div className={cn(containerClasses, { 'border-bodi-red-error': isInvalid })}>
        <button
          data-testid="quantityDecrease"
          className={cn(buttonClasses, 'border-r')}
          onClick={() => {
            onChange(value - 1)
          }}
        >
          <MinusIcon {...iconProps} />
        </button>
        <span className="flex w-[72px] justify-center font-medium">{value}</span>
        <button
          data-testid="quantityIncrease"
          className={cn(buttonClasses, 'border-l')}
          onClick={() => {
            onChange(value + 1)
          }}
        >
          <PlusIcon {...iconProps} />
        </button>
      </div>
    </div>
  )
}

export { QuantitySelector }
